import { AlertTriangle, Clock } from "lucide-react";

function daysUntil(dateStr) {
  if (!dateStr) return null;
  const diff = new Date(dateStr) - new Date();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export function PortalUrgencyBar({ customer }) {
  const alerts = [];

  const cashbackDays = daysUntil(customer?.cashback_expires_at);
  const cashback = customer?.cashback_balance || 0;
  if (cashbackDays !== null && cashbackDays >= 0 && cashbackDays <= 7 && cashback > 0) {
    alerts.push({
      msg: cashbackDays === 0
        ? `¡Tu saldo de ${cashback.toFixed(2)} € caduca HOY! Úsalo antes de perderlo.`
        : `Tu saldo de ${cashback.toFixed(2)} € caduca en ${cashbackDays} día${cashbackDays !== 1 ? "s" : ""}`,
      urgent: cashbackDays <= 1,
    });
  }

  const primeDays = daysUntil(customer?.prime_renewal_date);
  if (primeDays !== null && primeDays >= 0 && primeDays <= 3 && customer?.is_prime) {
    alerts.push({
      msg: primeDays === 0
        ? "Tu suscripción Prime se renueva hoy — revisa tu método de pago"
        : `Tu suscripción Prime se renueva en ${primeDays} día${primeDays !== 1 ? "s" : ""}`,
      urgent: false,
    });
  }

  const primeOfferDays = daysUntil(customer?.prime_offer_expires_at);
  if (primeOfferDays !== null && primeOfferDays >= 0 && primeOfferDays <= 2) {
    alerts.push({
      msg: primeOfferDays === 0
        ? "Oferta Prime exclusiva termina hoje!"
        : `Oferta Prime exclusiva termina em ${primeOfferDays} dia${primeOfferDays !== 1 ? "s" : ""}`,
      urgent: primeOfferDays === 0,
    });
  }

  if (alerts.length === 0) return null;

  return (
    <div className="space-y-2">
      {alerts.map((a, i) => (
        <div
          key={i}
          className={`flex items-center gap-2.5 rounded-xl px-4 py-2.5 text-sm ${
            a.urgent
              ? "bg-red-50 border border-red-200 text-red-700"
              : "bg-amber-50 border border-amber-200 text-amber-700"
          }`}
        >
          {a.urgent
            ? <AlertTriangle className="w-4 h-4 shrink-0" />
            : <Clock className="w-4 h-4 shrink-0" />
          }
          <span className="font-medium text-xs">{a.msg}</span>
        </div>
      ))}
    </div>
  );
}
